import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-packaging-reuse',
  template: `
    <p>
      packaging-reuse works!
    </p>
  `,
  styles: [
  ]
})
export class PackagingReuseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
